import React from 'react';
import { styles } from './QuantitySelect.css';
import { ArrowIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Arrow';

type QuantitySelectProps = {
  quantity: number;
  maxQty: number;
  onChange: (quantity: number) => void;
  label?: string;
  variant?: 'default' | 'small';
};

export const QuantitySelect = ({
  quantity,
  maxQty,
  onChange,
  label,
  variant = 'default',
}: QuantitySelectProps): JSX.Element => {
  return (
    <div className={styles.container({ variant })} data-testid="quantity-select-wrapper">
      {label ? (
        <label htmlFor="quantity" className={styles.label} data-testid="quantity-select-label">
          {label}
        </label>
      ) : null}

      <div className={styles.selectWrapper({ variant })}>
        <select
          id="quantity"
          className={styles.select({ variant })}
          onChange={e => onChange(Number(e.target.value))}
          data-testid="quantity-select"
          defaultValue={quantity}
        >
          {Array.from({ length: maxQty || 5 }, (_, index) => {
            const value = index + 1;
            return (
              <option key={index} value={value}>
                {value}
              </option>
            );
          })}
        </select>

        <div className={styles.iconWrapper({ variant })} aria-hidden="true">
          <ArrowIcon color="currentColor" width="16px" height="16px" />
        </div>
      </div>
    </div>
  );
};
